import { createFileRoute } from '@tanstack/react-router';
import {
  loadSimulationMessages,
  loadSimulationRenewalScreens,
  simulationDebtPurchaseScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute(
  '/_app/ccb/contratar/consignado-publico/novo-compra-de-divida/',
)({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationDebtPurchaseScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationRenewalScreens, 'DebtPurchaseRouteScreen'),
});
